import React from "react";
import { useSelector } from "react-redux";

import { BreachChart, getBreachChart } from "../state/selectedAsset";
import { Asset } from "../types/assets";

import TimeseriesChart from "./TimeseriesChart";
import TimeseriesDischargeChart from "./TimeseriesDischargeChart";

interface Props {
  asset: Asset;
}

interface ChildProps extends Props {
  breachGraph: BreachChart;
}

const TimeseriesBreachVelocityChart: React.FC<ChildProps> = ({ asset, breachGraph }) => (
  <TimeseriesChart
    asset={asset}
    data={breachGraph.map((item) => ({
      timestamp: item.timestamp,
      value: item.discharge / item.area,
    }))}
    type={"Velocity"}
  />
);
const TimeseriesBreachDischargeChart: React.FC<ChildProps> = ({ asset, breachGraph }) => (
  <TimeseriesDischargeChart
    asset={asset}
    dichargeGraph={breachGraph.map((item) => ({
      timestamp: item.timestamp,
      value: item.discharge,
    }))}
  />
);
const TimeseriesBreachWidthChart: React.FC<ChildProps> = ({ asset, breachGraph }) => (
  <TimeseriesChart
    asset={asset}
    data={breachGraph.map((item) => ({
      timestamp: item.timestamp,
      value: item.width,
    }))}
    type={"BreachWidth"}
  />
);
const TimeseriesBreachDepthChart: React.FC<ChildProps> = ({ asset, breachGraph }) => (
  <TimeseriesChart
    asset={asset}
    data={breachGraph.map((item) => ({
      timestamp: item.timestamp,
      value: item.depth,
    }))}
    type={"BreachDepth"}
  />
);

const TimeseriesBreachAreaChart: React.FC<ChildProps> = ({ asset, breachGraph }) => (
  <TimeseriesChart
    asset={asset}
    data={breachGraph.map((item) => ({
      timestamp: item.timestamp,
      value: item.area,
    }))}
    type={"BreachArea"}
  />
);

const TimeseriesBreachCharts: React.FC<Props> = ({ asset }) => {
  const breachGraph = useSelector(getBreachChart);
  return (
    <>
      <TimeseriesBreachVelocityChart asset={asset} breachGraph={breachGraph} />
      <TimeseriesBreachDischargeChart asset={asset} breachGraph={breachGraph} />
      <TimeseriesBreachWidthChart asset={asset} breachGraph={breachGraph} />
      <TimeseriesBreachDepthChart asset={asset} breachGraph={breachGraph} />
      <TimeseriesBreachAreaChart asset={asset} breachGraph={breachGraph} />
    </>
  );
};

export default TimeseriesBreachCharts;
